module.exports = __webpack_public_path__ + "img/arrow_tip_ico.ef6d2ac1.svg";